// Letterbox math ported from the extension's legacy Snap implementation
// (Composables/useDesigner.js lines 51–166). Pure function, no DOM, easy to
// unit-test.

export function computeLetterbox(naturalW, naturalH, innerW, innerH) {
  const sw = innerW / naturalW;
  const sh = innerH / naturalH;
  const s = Math.min(sw, sh);
  const dw = naturalW * s;
  const dh = naturalH * s;
  const ox = (innerW - dw) / 2;
  const oy = (innerH - dh) / 2;
  return { ox, oy, dw, dh, scale: s };
}
